import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authStatusSelector } from "../services/redux/slices/authSlice";
import { RootState } from "../services/redux/store";

const UnAuthRoutes = () => {
  const authStatus = useSelector(authStatusSelector);
  const location = useLocation();

  const loanCategory = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );

  // Mobile app deep link (/apply-now?_wsAuth=...): DashboardLayoutJourny sets
  // the session and navigates itself (appType / preLogin decide where). Redux
  // updates render synchronously while router navigation is a transition
  // (v7_startTransition), so without this guard the auth flip would redirect
  // here first and override that navigate (e.g. appType=new_application).
  if (new URLSearchParams(location.search).has("_wsAuth")) {
    return <Outlet />;
  }

  if (loanCategory?.Flexi?.length == 0 && loanCategory?.TermLoan?.length == 0) {
    return <Navigate to="/application/existing-application" replace />;
  } else if (loanCategory?.Flexi?.length > 0 || loanCategory?.TermLoan?.length > 0) {
    return <Navigate to="/dashboard" replace />;
  }

  return !authStatus ? <Outlet /> : <Navigate to="/application/existing-application" replace />;
};

export default UnAuthRoutes;
